import React from 'react'
import Snackbar from 'material-ui/Snackbar'

import { withMessages } from './Msg'

class NewVersionPrompt extends React.Component {
  state = { open: false }

  render() {
    const { messages } = this.props
    return (
      <Snackbar
        open={this.state.open}
        message={messages['NewVersionPrompt.message']}
        action={messages['NewVersionPrompt.action']}
        onActionClick={this.reload}
      />
    )
  }

  reload = () => window.location.reload()

  onNewVersion = () => this.setState({ open: true })

  componentDidMount() {
    window.addEventListener('newVersionAvailable', this.onNewVersion)
  }

  componentWillUnmount() {
    window.removeEventListener('newVersionAvailable', this.onNewVersion)
  }
}

export default withMessages(NewVersionPrompt)



// WEBPACK FOOTER //
// ./src/components/NewVersionPrompt.js